/** The API answers a malformed id with 400 and an unknown one with 404; either way the record does not exist. */
export const isNotFoundQueryError = (error: unknown): boolean =>
	typeof error === 'object'
	&& error !== null
	&& 'status' in error
	&& (error.status === 404 || error.status === 400);

/** 401: no valid sign-in for the resource; 403: an invalid or revoked share key. */
export const isNoAccessQueryError = (error: unknown): boolean =>
	typeof error === 'object'
	&& error !== null
	&& 'status' in error
	&& (error.status === 401 || error.status === 403);
